const personalDataKeys = [
  {
    name: "personal_identity_no",
    dataType: "string"
  },
  {
    name: "status",
    dataType: "string"
  },
  {
    name: "protected_identity",
    dataType: "bool"
  },
  {
    name: "deceased_date",
    dataType: "string"
  },
  {
    name: "changed_date",
    dataType: "string"
  },
  {
    name: "first_name",
    dataType: "string"
  },
  {
    name: "middle_name",
    dataType: "string"
  },
  {
    name: "last_name",
    dataType: "string"
  },
  {
    name: "full_name",
    dataType: "string"
  },
  {
    name: "lk_code",
    dataType: "string"
  },
  {
    name: "address_type",
    dataType: "string"
  },
  {
    name: "co_address",
    dataType: "string"
  },
  {
    name: "street_address",
    dataType: "string"
  },
  {
    name: "street_address_cont",
    dataType: "string"
  },
  {
    name: "postal_code",
    dataType: "string"
  },
  {
    name: "post_town",
    dataType: "string"
  },
  {
    name: "phone_no",
    dataType: "string"
  },
  {
    name: "nix_mark",
    dataType: "bool"
  },
  {
    name: "mobile_no",
    dataType: "string"
  },
];

export default personalDataKeys;



// WEBPACK FOOTER //
// ./src/data/personalDataKeys.js